export enum PowerBiObjectType {
    Dashboard,
    Report
}